import { FC, PropsWithChildren, useEffect, useMemo } from "react";
import { SocketContext } from "@shared/features/socket/Socket.context";
import { socketHandler } from "app/shared/utils";
import useNetConnection from "utils/hooks/useNetConnection";
import { useSelector } from "react-redux";
import { sharedLib } from "@shared/services/shared.service";
import { setIsOnline } from "@shared/common/constants";
import { IS_WEB_VIEW } from "common/constants.ts";
import { useIsWindowFocused } from "utils/hooks/misc.tsx";
import { IS_TELEGRAM_WEB_APP } from "features/telegram/constants";
import { getIsMockApiEnabled } from "app/shared/utils";

const SocketProvider: FC<PropsWithChildren> = ({ children }) => {
  const hasToken = !!useSelector(
    sharedLib.selectors.authentication.selectToken
  );
  const hasUser = !!useSelector(sharedLib.selectors.authentication.selectUser);
  useNetConnection({
    onChange: setIsOnline,
  });
  const focused = useIsWindowFocused();

  useEffect(() => {
    if (!IS_WEB_VIEW && !IS_TELEGRAM_WEB_APP) return;
    if (focused) {
      setTimeout(() => {
        socketHandler.onAppForeground();
      }, 500);
    } else {
      socketHandler.onAppBackground();
    }
  }, [focused]);

  useEffect(() => {
    if (getIsMockApiEnabled()) return;
    if (hasUser && hasToken) {
      socketHandler.initialize();
    } else {
      socketHandler.clear();
    }
  }, [hasUser, hasToken]);

  const contextValue = useMemo(() => {
    return {
      socketHandler,
    };
  }, []);

  return (
    <SocketContext.Provider value={contextValue}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;
